import React, { useContext, useEffect } from 'react'
import ReactGA from 'react-ga4'
import { AuthProvider, AuthContext } from '../context/firebase-context'
import { identifyClarityUser } from '../services/clarity'
import SentryBindings from './SentryBindings'

const GA_ID = process.env.REACT_APP_GA_ID
// Only set in the production env, so Clarity never loads outside production.
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID

// Ties Clarity sessions to our user uuid once the auth context resolves, so
// recordings can be looked up by user. Lives inside AuthProvider; renders
// nothing.
function ClarityUserBinding () {
  const user = useContext(AuthContext)
  useEffect(() => {
    identifyClarityUser(user)
  }, [user?.userUuid])
  return null
}

export default function Providers ({ children }) {
  useEffect(() => {
    if (GA_ID) ReactGA.initialize(GA_ID)
  }, [])

  useEffect(() => {
    if (!CLARITY_ID || window.clarity) return
    // Standard async Microsoft Clarity loader – non-blocking, injected after mount.
    ;(function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
    })(window, document, 'clarity', 'script', CLARITY_ID)
  }, [])

  return (
    <AuthProvider>
      <ClarityUserBinding />
      <SentryBindings />
      {children}
    </AuthProvider>
  )
}
